import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);



const gallery = () => {
    gsap.set(".oxy-gallery-item", { opacity: 0 });
    ScrollTrigger.batch(".oxy-gallery-item", {
        onEnter: (batch) => gsap.to(batch, { 
            opacity: 1, stagger: 0.1 }),
      });

}

export default gallery;